import { render, staticRenderFns } from "./order-fulfilmentlist.vue?vue&type=template&id=c0803c6c&"
import script from "./order-fulfilmentlist.vue?vue&type=script&lang=js&"
export * from "./order-fulfilmentlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports